import React from 'react'
import './NoPermissions.css'
import ReactLoading from "react-loading";

function LoaderPermissions({isHeight}) {
    return (
        <main>
            <div className="margin_main no-per" style={isHeight ? {height: "70vh"}: {height: "80vh"}}>
                <ReactLoading
                    type="spin"
                    color="black"
                    height={"2%"}
                    width={"2%"}
                />
            </div>
        </main>
    )
}

export default LoaderPermissions
